import type { IconSvgObject } from './types';

const YogaMatIcon: IconSvgObject = [
  ["path", { d: "M6 13.5C6 15.0122 7 16 8.5 16C10.5 16 11.166 14.1024 10.5 12.5C9.82305 10.8712 8.37387 10 6.5 10C4.01472 10 2 12.0147 2 14.5C2 16.9853 4.01472 19 6.5 19H13.6667C13.883 19 14.0936 18.9298 14.2667 18.8L22 13L18 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 15.5L18 9.5C18 8.5 17.9438 8.02029 17.5942 7.37468C16.8289 5.96131 15.322 5 13.5883 5C12.6546 5 11.7867 5.2788 11.065 5.75685L4 10.7508", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default YogaMatIcon;
